module.exports = __webpack_public_path__ + "static/bnr_square-91cf90405560be1fa29bf69a4a8e3798.png";